import React from "react";

export default function VideoProcessingAdvancedToggle({ enabled = false, onChange = null, style = null }) {
	return (
		<div style={style || null}>
			<label style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", fontWeight: 600, cursor: "pointer" }}>
				<input type="checkbox" checked={enabled} onChange={onChange || undefined} />
				<span>Show Advanced Video Options</span>
			</label>
			<div style={{ color: "#6b7280", fontSize: "12px", lineHeight: 1.4 }}>
				Prompt for ffmpeg processing settings when uploading videos through AmbiFi Cloud.
			</div>
		</div>
	);
}
